import React, { useState, useEffect, useRef } from 'react';
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { toWeb48Countdown } from "../web48Offer";

const Wrapper = styled.div<{ height: number }>`
  height: ${props => props.height}px;
  background-color: #F5F5F5;
`;


const StickyBanner = styled.div`
  box-sizing: border-box;
  position: fixed;
  width: 100%;
  left: 0px;
  top: var(--referral-banner-height, 0px);
  background: linear-gradient(275.4deg, #074199 45.31%, #0B6DFF 59.75%);
  border-bottom: 4px solid #0558D4;
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -4px rgba(0, 0, 0, 0.1);
  border-radius: 0px;
  z-index: 1000;
`;

const StickyContent = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  padding: 12px 16px;

  @media (min-width: 900px) {
    padding: 10px 32px 8px 16px;
    max-width:1050px;
    margin:0 auto;
  }
`;

const StickyIcon = styled.div`
  display: block;
  @media (min-width: 900px) {
    display: block;
  }
`;

const StickyText = styled.div`
  font-size: 16px;
  color: white;
  margin-left: 10px;
`;

const StickyTextLine1 = styled.div`
  font-family: 'Oswald';
  font-style: normal;
  font-weight: 700;
  font-size: 10px;
  line-height: 14px;
  letter-spacing: 0.4px;
  color: #FFFFFF;
  display:block;

  @media (min-width: 900px) {
    font-size: 16px;
    line-height: 16px;
    display:none;
  }
`;

// $single: no lead-in line above it (web40 kit copy), so it carries the
// whole message and gets a larger mobile size.
const StickyTextLine2 = styled.div<{ $single?: boolean }>`
  font-family: 'Oswald';
  font-style: normal;
  font-weight: 500;
  font-size: ${({ $single }) => ($single ? '17px' : '12px')};
  line-height: ${({ $single }) => ($single ? '20px' : '14px')};
  ${({ $single }) => ($single ? 'white-space: pre-line;' : '')}
  color: #FFFFFF;
  display:block;

  @media (min-width: 900px) {
    font-size: 20px;
    line-height: 24px;
    display:none;
    
  }
`;


const StickyTextLine3 = styled.div`
  font-family: 'Oswald';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  color: #FFFFFF;
  display:none;

  @media (min-width: 900px) {
    font-size: 20px;
    line-height: 24px;
    display:block;
  }
`;
const StickyTimer = styled.div<{ $wide?: boolean }>`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 6px 12px;
  gap: 12px;
  margin-left: auto;
  width:110px;
  background: rgba(255, 255, 255, 0.1);
  border: 2px solid rgba(255, 255, 255, 0.5);
  border-radius: 1000px;

  @media (min-width: 769px) {
  width:130px;
    padding: 3px 16px 3px 16px
  }
  /* web48: days:hours:min:sec needs twice the room; the icon hides on phones. */
  ${({ $wide }) => ($wide ? `
    width: auto;
    flex-shrink: 0;
    padding: 6px 10px;
    gap: 8px;
    @media (max-width: 768px) {
      > :first-child { display: none; }
    }
    @media (min-width: 769px) {
      width: auto;
      padding: 3px 16px;
    }
  ` : '')}
  /* "Ends in:" is visible from 900px and carries the auto margin instead. */
  @media (min-width: 900px) {
    margin-left: 0;
  }
  /* web48 past the end date: no "Ends in:" label, so the pill takes the margin. */
  @media (min-width: 900px) {
    &[data-ended] {
      margin-left: auto;
    }
  }
`;

const StickyTimerIcon = styled.div`
  width: 12px;
  height: 12px;
  display: flex;
  svg {
    width: 100%;
    height: 100%;
  }
  @media (min-width: 769px) {
    width: 24px;
    height: 24px;
  }
`;

const StickyTimerText = styled.div``;

const EndsText = styled.div`
 font-family: 'Oswald';
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
        line-height: 24px;
  color: #FFFFFF;
  
  margin-right: 0px;
    position: relative;
    width: 44%;
    display: flex;
    flex-direction: row-reverse;
    display:none;
  @media (min-width: 900px) {
  font-family: 'Oswald';
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
        line-height: 24px;
  color: #FFFFFF;
  
  /* Hug the timer whatever the banner copy's length: push this label to the
     right edge (the timer below drops its own auto margin at this width) and
     keep a fixed gap to the pill. The old fixed 44% box only lined up when the
     copy was long enough to fill the row. */
  margin-left: auto;
  margin-right: 12px;
    position: relative;
    width: auto;
    display: flex;
    flex-direction: row-reverse;
  display:flex;
  }
`;


const StickyTimerTextLine1 = styled.div`
  font-family: 'Oswald';
  font-style: normal;
  font-weight: 500;
  font-size: 8px;
  line-height: 10px;
  letter-spacing: 0.7px;
  text-transform: uppercase;
  color: #FFFFFF;
  display: block;

  @media (min-width: 769px) {
    display: block;
     font-size: 10px;
  line-height: 15px;
  }
`;

const StickyTimerTextLine2 = styled.div`
  font-family: 'Oswald';
  font-style: normal;
  font-weight: 700;
  color: #FFFFFF;
  letter-spacing: 0px;
  line-height: 12px;
   &  span.digits {
   display:flex;
      
    flex-direction: column;
        margin-left:3px;
     margin-right:3px;
   }
  &  span.digits2col {
   display:flex;
      
    flex-direction: row;

   }

  &  span.digit {
    font-variant-numeric: tabular-nums;
    font-size: 18px;
    @media (min-width: 769px) {
      font-size: 20px;
    }
  }
  &  span.ended {
    display: block;
    font-size: 18px;
    line-height: 24px;
    text-transform: uppercase;
    white-space: nowrap;
    @media (min-width: 769px) {
      font-size: 20px;
      line-height: 30px;
    }
  }
  &  span.unit {
    font-size: 10px;
        margin-top: 2px;
    text-align: center;
    @media (min-width: 769px) {
      font-size: 10px;
        margin-top: -4px;
    }
  }

  @media (min-width: 769px) {
    line-height: 21px;
  }
`;

interface Project60StickyBannerProps {
  line1?: string;
  line2?: string;
  showTimer?: boolean;
  showBanner?:boolean;
  // web29 legit timer: absolute deadline (ms epoch) persisted by web29Offer.
  // When set, the countdown is derived from it every tick so reloads and new
  // tabs can't restart the clock. When unset, the original 10-minute
  // in-memory countdown runs (urgency-offer arm, unchanged).
  expiresAt?: number;
  // Desktop single-line copy (line1/line2 are the stacked mobile lines).
  line3?: string;
  // web48: count down days:hours:min:sec to expiresAt instead of min:sec.
  showDays?: boolean;
  // web48: once expiresAt has passed, the pill shows this text instead of
  // 00:00:00:00 and the "Ends in:" label goes.
  endedText?: string;
}

const msToMinSec = (ms: number) => [Math.floor(ms / (1000 * 60)), Math.floor((ms / 1000) % 60)];

export const Project60StickyBanner = ({
  line1: line1Prop,
  line2: line2Prop,
  showTimer = true,
  showBanner =true,
  expiresAt,
  line3: line3Prop,
  showDays = false,
  endedText,
}: Project60StickyBannerProps) => {
  const { t } = useTranslation();
  // Defaults apply only to undefined (as default parameters did): "" stays "".
  const line1 = line1Prop ?? t("results.banner.defaultLine1");
  const line2 = line2Prop ?? t("results.banner.defaultLine2");
  const line3 = line3Prop ??
    `${t("results.banner.specialDiscountUnlocked")} ${t("results.banner.percentOffTrial", { percent: 20 })}`;
  const [bannerHeight, setBannerHeight] = useState<number>(0);
  const bannerRef = useRef<HTMLDivElement>(null);
  const [timeRemaining, setTimeRemaining] = useState<number[]>(() =>
    expiresAt !== undefined ? msToMinSec(Math.max(0, expiresAt - Date.now())) : [10, 0]
  );
  // Remaining ms for the days:hours:min:sec format (web48).
  const [remainingMs, setRemainingMs] = useState(() =>
    expiresAt !== undefined ? Math.max(0, expiresAt - Date.now()) : 10 * 60 * 1000
  );
  const isEnded = endedText !== undefined && expiresAt !== undefined && remainingMs <= 0;
  const remainingMsRef = useRef(10 * 60 * 1000);
  const lastTickRef = useRef(Date.now());
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const startInterval = () => {
    lastTickRef.current = Date.now();
    if (intervalRef.current) clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      const now = Date.now();
      if (expiresAt !== undefined) {
        remainingMsRef.current = Math.max(0, expiresAt - now);
      } else {
        const elapsed = now - lastTickRef.current;
        remainingMsRef.current = Math.max(0, remainingMsRef.current - elapsed);
      }
      lastTickRef.current = now;

      setTimeRemaining(msToMinSec(remainingMsRef.current));
      setRemainingMs(remainingMsRef.current);

      if (remainingMsRef.current <= 0) {
        if (intervalRef.current) clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    }, 100);
  };

  const stopInterval = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  useEffect(() => {
    startInterval();

    const handleVisibilityChange = () => {
      if (document.hidden) {
        stopInterval();
      } else {
        startInterval();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      stopInterval();
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expiresAt]);

  useEffect(() => {
    const bannerElement = bannerRef.current;
    if (!bannerElement) return;

    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const { height } = entry.contentRect;
        setBannerHeight(height);
      }
    });

    resizeObserver.observe(bannerElement);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <> {showBanner &&  <Wrapper height={bannerHeight}>
      <StickyBanner ref={bannerRef} data-testid="urgency-banner">
        <StickyContent>
          <StickyIcon>
            <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 18C0 8.05888 8.05888 0 18 0C27.9411 0 36 8.05888 36 18C36 27.9411 27.9411 36 18 36C8.05888 36 0 27.9411 0 18Z" fill="white" fill-opacity="0.1"/>
              <path d="M24 15H12C11.5858 15 11.25 15.3358 11.25 15.75V17.25C11.25 17.6642 11.5858 18 12 18H24C24.4142 18 24.75 17.6642 24.75 17.25V15.75C24.75 15.3358 24.4142 15 24 15Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M18 15V24.75" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M23.25 18V23.25C23.25 23.6478 23.092 24.0294 22.8107 24.3107C22.5294 24.592 22.1478 24.75 21.75 24.75H14.25C13.8522 24.75 13.4706 24.592 13.1893 24.3107C12.908 24.0294 12.75 23.6478 12.75 23.25V18" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M14.625 15.0003C14.1277 15.0003 13.6508 14.8028 13.2992 14.4512C12.9475 14.0995 12.75 13.6226 12.75 13.1253C12.75 12.628 12.9475 12.1511 13.2992 11.7995C13.6508 11.4479 14.1277 11.2503 14.625 11.2503C15.3485 11.2377 16.0575 11.5888 16.6596 12.2577C17.2616 12.9266 17.7287 13.8824 18 15.0003C18.2713 13.8824 18.7384 12.9266 19.3404 12.2577C19.9425 11.5888 20.6515 11.2377 21.375 11.2503C21.8723 11.2503 22.3492 11.4479 22.7008 11.7995C23.0525 12.1511 23.25 12.628 23.25 13.1253C23.25 13.6226 23.0525 14.0995 22.7008 14.4512C22.3492 14.8028 21.8723 15.0003 21.375 15.0003" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </StickyIcon>
          <StickyText>
            {line1 ? <StickyTextLine1>{line1}</StickyTextLine1> : null}
            <StickyTextLine2 $single={!line1}>{line2}</StickyTextLine2>
             <StickyTextLine3>{line3}</StickyTextLine3>
            
          </StickyText>
          {showTimer && !isEnded && <EndsText>{t("results.banner.endsIn")}</EndsText>}
          {showTimer && <StickyTimer $wide={showDays} data-testid="urgency-banner-timer" data-ended={isEnded || undefined}>

           
      <StickyTimerIcon>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g opacity="0.99604">
                <path d="M12 6V12L16 14" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M11.9961 22C17.5189 22 21.9961 17.5228 21.9961 12C21.9961 6.47715 17.5189 2 11.9961 2C6.47325 2 1.99609 6.47715 1.99609 12C1.99609 17.5228 6.47325 22 11.9961 22Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </g>
              </svg>
            </StickyTimerIcon>
     
            <StickyTimerText>
              {/*    <StickyTimerTextLine1>ends in</StickyTimerTextLine1> */}
              <StickyTimerTextLine2>
                {isEnded ? (
                  <span className="ended">{endedText}</span>
                ) : showDays ? (
                  <span className='digits2col'>
                    {(() => {
                      const c = toWeb48Countdown(remainingMs);
                      const parts: [number, string][] = [
                        [c.days, t("results.banner.unitDays")],
                        [c.hours, t("results.banner.unitHours")],
                        [c.minutes, t("results.banner.unitMinutes")],
                        [c.seconds, t("results.banner.unitSeconds")],
                      ];
                      return parts.map(([value, unit], i) => (
                        <React.Fragment key={unit}>
                          {i > 0 && ':'}
                          <span className='digits'><span className="digit">{String(value).padStart(2, '0')}</span><span className="unit">{unit}</span></span>
                        </React.Fragment>
                      ));
                    })()}
                  </span>
                ) : (
                <span className='digits2col'>
                <span className='digits'><span className="digit">{String(timeRemaining[0]).padStart(2, '0')} </span><span className="unit">{t("results.banner.unitMinutes")}</span></span>:
                <span className='digits'> <span className="digit">{String(timeRemaining[1]).padStart(2, '0')}</span>
                <span className="unit">{t("results.banner.unitSeconds")}</span></span>
                 </span>
                )}
              </StickyTimerTextLine2>
            </StickyTimerText>
          </StickyTimer>}
        </StickyContent>
      </StickyBanner>
    </Wrapper>
          }</>
  );    
};
